/** Fixed right-edge control that opens the appearance dialog. */
import { Palette } from 'lucide-react';

type AppearanceFabProps = {
  readonly open: boolean;
  readonly onClick: () => void;
};

export function AppearanceFab({ open, onClick }: AppearanceFabProps) {
  return (
    <button
      type="button"
      className={`appearance-fab${open ? ' is-open' : ''}`}
      aria-label="Open appearance settings"
      aria-expanded={open}
      aria-haspopup="dialog"
      aria-controls="appearance-dialog"
      onClick={onClick}
    >
      <span className="appearance-fab-icon" aria-hidden>
        <span className="appearance-fab-pulse" />
        <Palette size={18} strokeWidth={2.1} />
      </span>
      <span className="appearance-fab-label">Theme</span>
    </button>
  );
}
